import { beforeEnterCmmon } from "../method/method";

// H5页面，知识库
export default [
  // 知识
  {
    path: "/knowledgeH5",
    name: "knowledgeH5",
    component: () => import("@/CommonDP/pages/appView/knowledgeH5/index.vue"),
    beforeEnter: beforeEnterCmmon
  },
  // 知识--个人文档
  {
    path: "/personDocH5",
    name: "personDocH5",
    component: () => import("@/CommonDP/pages/appView/knowledgeH5/personDocH5/index.vue"),
    beforeEnter: beforeEnterCmmon
  },
  // 知识--企业文档
  {
    path: "/enterpriseDocH5",
    name: "enterpriseDocH5",
    component: () => import("@/CommonDP/pages/appView/knowledgeH5/enterpriseDocH5/index.vue"),
    beforeEnter: beforeEnterCmmon
  },
  // 知识--部门文档
  {
    path: "/deptDocH5",
    name: "deptDocH5",
    component: () => import("@/CommonDP/pages/appView/knowledgeH5/deptDocH5/index.vue"),
    beforeEnter: beforeEnterCmmon
  },
  // 知识--个人文档--我的文档
  {
    path: "/personDocH5/myDocH5",
    name: "myDocH5",
    component: () => import("@/CommonDP/pages/appView/knowledgeH5/personDocH5/myDocH5"),
    beforeEnter: beforeEnterCmmon
  },
  // 知识--个人文档--我的分享
  {
    path: "/personDocH5/myShareH5",
    name: "myShareH5",
    component: () => import("@/CommonDP/pages/appView/knowledgeH5/personDocH5/myShareH5"),
    beforeEnter: beforeEnterCmmon
  },
  // 知识--个人文档--我的收藏
  {
    path: "/personDocH5/myCollectionH5",
    name: "myCollectionH5",
    component: () => import("@/CommonDP/pages/appView/knowledgeH5/personDocH5/myCollectionH5"),
    beforeEnter: beforeEnterCmmon
  },
  // 知识--个人文档--我的回收站
  {
    path: "/personDocH5/myRecycleH5",
    name: "myRecycleH5",
    component: () => import("@/CommonDP/pages/appView/knowledgeH5/personDocH5/myRecycleH5"),
    beforeEnter: beforeEnterCmmon
  },
  // 知识--企业文档--分享资料
  {
    path: "/enterpriseDocH5/shareInfoH5",
    name: "shareInfoH5",
    component: () => import("@/CommonDP/pages/appView/knowledgeH5/enterpriseDocH5/shareInfoH5"),
    beforeEnter: beforeEnterCmmon
  },
  // 知识--企业文档--公共资料
  {
    path: "/enterpriseDocH5/publicInfoH5",
    name: "publicInfoH5",
    component: () => import("@/CommonDP/pages/appView/knowledgeH5/enterpriseDocH5/publicInfoH5"),
    beforeEnter: beforeEnterCmmon
  },
  // 知识--企业文档--回收站
  {
    path: "/enterpriseDocH5/epRecycleH5",
    name: "epRecycleH5",
    component: () => import("@/CommonDP/pages/appView/knowledgeH5/enterpriseDocH5/epRecycleH5"),
    beforeEnter: beforeEnterCmmon
  },
  // 知识--部门文档--部门内容
  {
    path: "/deptDocH5/deptInfoH5",
    name: "deptInfoH5",
    component: () => import("@/CommonDP/pages/appView/knowledgeH5/deptDocH5/deptInfoH5"),
    beforeEnter: beforeEnterCmmon
  },
  // 知识--部门文档--部门回收站
  {
    path: "/deptDocH5/deptRecycleH5",
    name: "deptRecycleH5",
    component: () => import("@/CommonDP/pages/appView/knowledgeH5/deptDocH5/deptRecycleH5"),
    beforeEnter: beforeEnterCmmon
  }
];
